import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["dice"];

  connect() {
    this.currentIndex = 0;
    this.animationInterval = null;
    this.isAnimating = false;
    this.animationInProgress = false;
    this.initializeDice();
  }

  initializeDice() {
    this.diceTargets.forEach((dice, index) => {
      if (index === 2) {
        dice.classList.remove("opacity-0");
        dice.classList.add("opacity-100");
      } else {
        dice.classList.remove("opacity-100");
        dice.classList.add("opacity-0");
      }
    });
  }

  startAnimation() {
    if (this.isAnimating) return;

    this.isAnimating = true;
    this.animationInterval = setInterval(() => {
      if (!this.animationInProgress) {
        this.showRandomDice();
      }
    }, 150);
  }

  stopAnimation() {
    if (this.animationInterval) {
      clearInterval(this.animationInterval);
      this.animationInterval = null;
      this.isAnimating = false;
    }
  }

  selectRandom() {
    this.stopAnimation();
    if (!this.animationInProgress) {
      this.showRandomDice();
    }
  }

  showRandomDice() {
    // Prevent multiple transitions at once
    if (this.animationInProgress) return;
    this.animationInProgress = true;

    // Get random index (different from current)
    let randomIndex;
    do {
      randomIndex = Math.floor(Math.random() * this.diceTargets.length);
    } while (randomIndex === this.currentIndex && this.diceTargets.length > 1);

    // First make new dice visible (cross-fade approach)
    const newDice = this.diceTargets[randomIndex];
    newDice.classList.remove("opacity-0");
    newDice.classList.add("opacity-100");

    // Small delay before hiding the old dice
    setTimeout(() => {
      // Now hide the old dice
      const currentDice = this.diceTargets[this.currentIndex];
      currentDice.classList.remove("opacity-100");
      currentDice.classList.add("opacity-0");

      this.currentIndex = randomIndex;

      // Allow next animation after transition completes
      setTimeout(() => {
        this.animationInProgress = false;
      }, 200); // Match to CSS transition duration
    }, 50); // Small overlap for smooth crossfade
  }
}
